const HelperLib = {
  createBasicShareLink(link) {
    return `${process.env.BASE_URL}/basic-chart/?i=${link}`
  },
  createShareLink(link) {
    return `${process.env.BASE_URL}/chart/?i=${link}`
  },
  isMobile() {
    var isMobile = /android.+mobile|ip(hone|[oa]d)/i.test(navigator.userAgent)
    var isMobile2 = window.innerWidth < 720 ? true : false;
    return isMobile || isMobile2
  },
  paddy(num, padlen, padchar) {
    var padChar = typeof padchar !== 'undefined' ? padchar : '0'
    var pad = new Array(1 + padlen).join(padChar)
    return (pad + num).slice(-pad.length)
  },
  formatDegText(deg, min, sec) {
    return '' + this.paddy(deg, 2, 0) + '°' + this.paddy(min, 2, 0) + "'" + this.paddy(sec, 2, 0) + '"'
  },
  sansToEngGraha(sans) {
    var grahas = {
      'Sy': 'Su',
      'Ch': 'Mo',
      'Ma': 'Ma',
      'Bu': 'Me',
      'Gu': 'Ju',
      'Sk': 'Ve',
      'Sa': 'Sa',
      'Ra': 'Ra',
      'Ke': 'Ke'
    };
    for (var [key, value] of Object.entries(grahas)) {
      if (key == sans) {
        return value;
      }
    }
  },
  grahaToPersianText(graha) {

    var grahas = {
      'Su': ['خورشید', `${process.env.BASE_URL}/planet-sun-astrology/`],
      'Mo': ['ماه', `${process.env.BASE_URL}/planet-moon-astrology/`],
      'Ma': ['مارس', `${process.env.BASE_URL}/planet-mars-astrology/`],
      'Me': ['مرکوری', `${process.env.BASE_URL}/planet-mercury-astrology/`],
      'Ju': ['ژوپیتر', `${process.env.BASE_URL}/planet-jupiter-astrology/`],
      'Ve': ['ونوس', `${process.env.BASE_URL}/planet-astrology-venus/`],
      'Sa': ['سترن', `${process.env.BASE_URL}/planet-saturn-astrology/`],
      'Ra': ['راهو', '#'],
      'Ke': ['کیتو', '#'],
    }
    return grahas[graha]
  },
  rashiToPersianText(rashi) {

    var rashis = [
      'ایریس (1)',
      'تورث (2)',
      'جمنای (3)',
      'کنسر (4)',
      'لیو (5)',
      'ویرگو (6)',
      'لیبرا (7)',
      'اسکورپیو (8)',
      'سجیتریس (9)',
      'کپریکورن (10)',
      'اکواریوس (11)',
      'پایسیس (12)',
    ]

    var links = [
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%a7%db%8c%d8%b1%db%8c%d8%b3/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%aa%d9%88%d8%b1%d8%ab/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%ac%d9%85%d9%86%d8%a7%db%8c/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%da%a9%d9%86%d8%b3%d8%b1/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d9%84%db%8c%d9%88/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d9%88%d8%b1%da%af%d9%88/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d9%84%db%8c%d8%a8%d8%b1%d8%a7/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%a7%d8%b3%da%a9%d9%88%d8%b1%d9%be%db%8c%d9%88/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%b3%d8%ac%db%8c%d8%aa%d8%b1%db%8c%d8%b3/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%da%a9%d9%be%d8%b1%db%8c%da%a9%d9%88%d8%b1%d9%86/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d8%a2%da%a9%d9%88%d8%a7%d8%b1%db%8c%d9%88%d8%b3/`,
      `${process.env.BASE_URL}/%d8%aa%d9%81%d8%b3%db%8c%d8%b1-%d8%b1%d8%a7%db%8c%d8%b2%db%8c%d9%86%da%af-%d9%be%d8%a7%db%8c%d8%b3%db%8c%d8%b3/`
    ]
    return [rashis[rashi - 1], links[rashi - 1]];
  },
  getLagnaImagePath(image) {
    return `${process.env.BASE_URL}/wp-content/uploads/2022/08/` + image + ".png";
  },
  weekToText(week_no) {
    if (week_no == 7) return 'شنبه'
    if (week_no == 1) return 'یکشنیه'
    if (week_no == 2) return 'دوشنبه'
    if (week_no == 3) return 'سه‌شنبه'
    if (week_no == 4) return 'چهارشنبه'
    if (week_no == 5) return 'پنج‌شنبه'
    if (week_no == 6) return 'جمعه'
  },
  durationFormat(n_of_days, with_days = false) {
    if (!with_days) {
      n_of_days = n_of_days / 86400
    }
    var years = Math.floor(n_of_days / 365)
    var months = Math.floor((n_of_days % 365) / 30)
    var days = Math.floor((n_of_days % 365) % 30)
    let out = ' '
    if (years > 0) {
      out += years + ' سال '
      if (months > 0) {
        out += ' و '
      }
    }
    if (months > 0) {
      out += months + ' ماه '
      if (days > 0) {
        out += ' و '
      }
    }
    if (days > 0) {
      out += days + ' روز '
    }
    return out
  },
  convertDMSToDegree(degrees, minutes, seconds, direction) {
    let dd = Number(degrees) + Number(minutes)/60 + Number(seconds)/3600;
    if (direction === 'S' || direction === 'W') {
      dd = -dd;
    }

    return dd;
  },
  convertDegreeToDMS(decimalDegrees, lng) {
    const dd = Number(decimalDegrees);
    const absDD = Math.abs(dd);
    const degrees = Math.floor(absDD);
    const minutes = Math.floor((absDD - degrees) * 60);
    const seconds = Number(((absDD - degrees) * 60 - minutes) * 60).toPrecision(12); // Use scientific numbers

    const direction = dd < 0 ? lng ? 'W' : 'S' : lng ? 'E' : 'N'
    const result = {
      dir: direction,
      deg: degrees,
      min: minutes,
      sec: seconds
    };
    return result
  },
  showLoading(){
    // if(document.getElementById('hora-loading')){
    //   document.getElementById('hora-loading').classList.remove('d-none')
    // }
  },
  hideLoading(){
    // if(document.getElementById('hora-loading')){
    //   document.getElementById('hora-loading').classList.add('d-none')
    // }
  }
}
export default HelperLib
